import { CoverIsFor } from '../../types/types';
import { coupleTierLimits, tierLimits } from '../config';
import { formatCurrency } from '../helpers';

export const isAHM = (healthFundId: number) => healthFundId === 2;

export const isBupa = (healthFundId: number) => healthFundId === 4;

export const isWestFund = (healthFundId: number) => healthFundId === 36;

export const isHIF = (healthFundId: number) => healthFundId === 17;

export const isNIB = (healthFundId: number) => healthFundId === 25;
export const isAustralianUnity = (healthFundId: number) => healthFundId === 3;

export const calculateMainPrice = (
  priceMain: string,
  priceDecimal: string,
): number => {
  if (!priceMain && !priceDecimal) {
    return 0;
  }

  return parseFloat(`${priceMain}.${priceDecimal}`) || 0;
};

export const isVisa = (cardNo: string) => {
  return cardNo.startsWith('4');
};

export const isMasterCard = (cardNo: string) => {
  return cardNo.startsWith('5') || cardNo.startsWith('2');
};

export const removeEmptyFields = (obj: any) => {
  return Object.keys(obj).reduce((acc, key) => {
    if (obj[key] !== '') {
      acc[key] = obj[key];
    }
    return acc;
  }, {} as any);
};

export const getBenefitNames = (
  benefitIds: number[],
  benefits: object & { benefit_id: number; benefit_name: string }[],
) => {
  return benefitIds
    .map((benefitId) => {
      const benefit = benefits.find((b) => b.benefit_id === benefitId);
      return benefit ? benefit.benefit_name : '';
    })
    .filter(Boolean);
};
export const isValidDate = (date: string) => {
  if (!date) {
    return false;
  }
  const [day, month, year] = date.split('/');
  const isValidDay = day?.length === 2 && day >= '01' && day <= '31';
  const isValidMonth = month?.length === 2 && month >= '01' && month <= '12';
  const isValidYear = year?.length === 4 && year >= '1900' && year <= '2100';
  return isValidDay && isValidMonth && isValidYear;
};

export const isOver18 = (date: string) => {
  const [day, month, year] = date.split('/').map(Number);
  const birthDate = new Date(year, month - 1, day);
  const today = new Date();
  const age = today.getFullYear() - birthDate.getFullYear();

  const monthDifference = today.getMonth() - birthDate.getMonth();
  if (
    monthDifference < 0 ||
    (monthDifference === 0 && today.getDate() < birthDate.getDate())
  ) {
    return age >= 18;
  }
  return age >= 18;
};

export const transferName = (name: string) => {
  if (!name) {
    return { first_name: '', last_name: '' };
  }
  const nameComponent = name.split(' ');

  return {
    first_name: nameComponent[0],
    //Last name
    ...(nameComponent.length === 2
      ? { last_name: nameComponent[1] }
      : nameComponent.length === 3
        ? { last_name: nameComponent[2] }
        : {}),
    ...(nameComponent.length === 3 && { middle_name: nameComponent[1] }),
  };
};

export const getTierOptions = (tierLimits: number[]) => {
  return [
    {
      label: `${formatCurrency(tierLimits[0])} or less (Base tier)`,
      value: '0',
    },
    {
      label: `${formatCurrency(tierLimits[0] + 1)} to ${tierLimits[1]} (Tier 1)`,
      value: '1',
    },
    {
      label: `${formatCurrency(tierLimits[1] + 1)} to ${formatCurrency(tierLimits[2])} (Tier 2)`,
      value: '2',
    },
    {
      label: `${formatCurrency(tierLimits[2] + 1)} and above (Tier 3)`,
      value: '3',
    },
    { label: "Don't apply rebate", value: '4' },
  ];
};

export const getTierOptionsByCoverType = (coverType: CoverIsFor) => {
  switch (coverType) {
    case CoverIsFor.Couple:
    case CoverIsFor.Family:
      return getTierOptions(coupleTierLimits);
    case CoverIsFor.Single:
    case CoverIsFor.SingleParentFamily:
      return getTierOptions(tierLimits);
    default:
      return getTierOptions(tierLimits);
  }
};

export const getTierName = (tierIndex: number) => {
  switch (tierIndex) {
    case 0:
      return 'Base tier';
    case 1:
      return 'Tier 1';
    case 2:
      return 'Tier 2';
    case 3:
      return 'Tier 3';
    case 4:
      return 'Don’t apply rebate';
    default:
      return '';
  }
};
